export enum BoardCustomFieldTypeEnum {
    INTEGER = 1,
    DECIMAL = 2,
    TEXT = 3,
    DATE = 4,
    DATETIME = 5,
}
